













import { defineComponent, computed } from '@nuxtjs/composition-api'

// Common
import { RESULTS_PER_PAGE_NUMBERS } from '@/common/static/search'

// Types
import { SearchResultsObjectInterface } from '@/types/search/searchTypes'
import { SupportResultsObjectInterface } from '@/types/support/knowledgeBaseTypes'

export default defineComponent({
  props: {
    results: {
      type: Object as () => SearchResultsObjectInterface | SupportResultsObjectInterface,
      required: true,
    },
    currentValue: {
      type: Number,
      required: true,
    },
  },
  emits: ['onPaginationClick'],
  setup(props) {
    const filteredButtonNumbers = computed(() => {
      return RESULTS_PER_PAGE_NUMBERS.filter((number: number) => {
        const total = props.results.meta?.page?.total_results
        return total !== undefined && total > number
      })
    })

    return {
      filteredButtonNumbers,
    }
  },
})
